import React, { useState, useEffect } from 'react';
import axios from 'axios';

const PublicProductCatalog = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [stats, setStats] = useState({});

  // Добавляем CSS для адаптивности
  useEffect(() => {
    const style = document.createElement('style');
    style.textContent = `
      .product-grid {
        display: grid !important;
        gap: 12px !important;
        margin-bottom: 40px !important;
      }
      
      @media (max-width: 768px) {
        .product-grid {
          grid-template-columns: repeat(auto-fill, minmax(150px, 1fr)) !important;
          gap: 8px !important;
        }
      }
      
      @media (max-width: 480px) {
        .product-grid {
          grid-template-columns: repeat(2, 1fr) !important;
          gap: 6px !important;
        }
      }
      
      .stats-grid {
        display: grid !important;
        gap: 12px !important;
        margin-bottom: 20px !important;
      }
      
      @media (max-width: 768px) {
        .stats-grid {
          grid-template-columns: repeat(2, 1fr) !important;
          gap: 8px !important;
        }
      }
      
      @media (max-width: 480px) {
        .stats-grid {
          grid-template-columns: repeat(2, 1fr) !important;
          gap: 6px !important;
        }
      }
    `;
    document.head.appendChild(style);
    return () => document.head.removeChild(style);
  }, []);
  
  // Фильтры
  const [filters, setFilters] = useState({
    search: '',
    releaseDateFrom: '',
    releaseDateTo: '',
    status: '',
    page: 1
  });
  
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    totalItems: 0,
    itemsPerPage: 12
  });

  // Загрузка продуктов
  const loadProducts = async () => {
    try {
      setLoading(true);
      setError('');
      
      const params = new URLSearchParams();
      if (filters.search) params.append('search', filters.search);
      if (filters.releaseDateFrom) params.append('releaseDateFrom', filters.releaseDateFrom);
      if (filters.releaseDateTo) params.append('releaseDateTo', filters.releaseDateTo);
      if (filters.status) params.append('status', filters.status);
      params.append('page', filters.page);
      params.append('limit', 12);

      const response = await axios.get(`https://limitverify.ru:5000/api/public/products?${params}`);
      
      setProducts(response.data.products);
      setPagination(response.data.pagination);
    } catch (err) {
      console.error('Error loading products:', err);
      setError('Ошибка загрузки каталога');
    } finally {
      setLoading(false);
    }
  };

  // Загрузка статистики
  const loadStats = async () => {
    try {
      const response = await axios.get('https://limitverify.ru:5000/api/public/products/stats');
      setStats(response.data);
    } catch (err) {
      console.error('Error loading stats:', err);
    }
  };

  useEffect(() => {
    loadProducts();
    loadStats();
  }, [filters]);

  const handleFilterChange = (key, value) => {
    setFilters(prev => ({
      ...prev,
      [key]: value,
      page: 1 // Сбрасываем страницу при изменении фильтров
    }));
  };

  const handlePageChange = (page) => {
    setFilters(prev => ({ ...prev, page }));
  };

  const getStatusText = (status) => {
    const statusMap = {
      'ACTIVE': 'В продаже',
      'INACTIVE': 'Снят с продажи',
      'DISCONTINUED': 'Снят с производства'
    };
    return statusMap[status] || status;
  };

  const getStatusColor = (status) => {
    const colorMap = {
      'ACTIVE': '#1a472a',
      'INACTIVE': '#faad14',
      'DISCONTINUED': '#ff4d4f',
      'АКТИВНО': '#1a472a',
      'АРХИВ': '#8c8c8c',
      'АННУЛИРОВАНО': '#8c1913'
    };
    return colorMap[status] || '#666';
  };

  if (loading) {
    return null;
  }

  return null;
};

export default PublicProductCatalog;
